export default __webpack_public_path__ + "static/media/background.c7db0e9c.jpg";